export type AuthAlternativeMethod = "google" | "telegram" | "whatsapp";

const AUTH_METHOD_ORDER: readonly AuthAlternativeMethod[] = ["google", "telegram", "whatsapp"];
const AUTH_METHOD_ORDER_BY_MODE = {
  signin: AUTH_METHOD_ORDER,
  signup: AUTH_METHOD_ORDER,
} as const;

/** Keeps the provider hierarchy consistent across account creation and sign-in. */
export function getAuthAlternativeMethodOrder(mode: "signin" | "signup") {
  return AUTH_METHOD_ORDER_BY_MODE[mode];
}
